import React from "react";

export default function EnterPan() {
  return (
    <div>
      <p>EnterPan</p>
    </div>
  );
}
